// Web-only BFF bridge. OAuth credentials never enter browser storage or URL fragments.
const apiBase = process.env.VUE_APP_BASE_API || '/api';
export function usesUnifiedAuth() {
  return process.env.VUE_APP_SSO_ENABLED === 'true' && !window.acquireVsCodeApi && !window.vscodeServices && !/^#\/(vscode|plugin)(?:[/?]|$)/.test(location.hash);
}
export function sourcePath(route) {
  const path = route ? location.pathname + location.search + '#' + route : location.pathname + location.search + location.hash;
  return /#\/(login|register|sso\/)/.test(path) ? location.pathname + location.search + '#/home/index' : path;
}
export function beginUnifiedLogin(route) {
  const entry = new URL(apiBase.replace(/\/$/, '') + '/sso/login', location.origin);
  entry.searchParams.set('returnTo', sourcePath(route));
  location.assign(entry.href);
}
export function clearUnifiedCredentials() {
  for (const key of ['accessToken', 'refreshToken', 'tokenKey', 'happyToken', 'box.sso.csrf', 'box.sso']) sessionStorage.removeItem(key);
  localStorage.removeItem('userInfo');
  localStorage.removeItem('happyToken');
}
export async function ssoRequest(path, data) {
  const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 15000);
  let response;
  try { response = await fetch(apiBase.replace(/\/$/, '') + '/sso' + path, {
    signal: controller.signal,
    method: data ? 'POST' : 'GET', credentials: 'include', cache: 'no-store',
    headers: {'X-SSO-Request': '1', ...(data ? {'Content-Type': 'application/json', 'X-CSRF-Token': sessionStorage.getItem('box.sso.csrf') || ''} : {})},
    ...(data ? {body: JSON.stringify(data)} : {})
  }); } finally { clearTimeout(timeout); }
  const result = await response.json();
  if (!response.ok) { const error = new Error(result.message || '认证服务暂时不可用'); error.status = response.status; throw error; }
  return result;
}
let refreshing;
export function restoreUnifiedSession() {
  if (refreshing) return refreshing;
  refreshing = ssoRequest('/session').then(data => {
    if (data.reauthorizeUrl) return data;
    sessionStorage.setItem('box.sso.csrf', data.csrf);
    sessionStorage.setItem('box.sso', '1');
    if (data.login) {
      sessionStorage.setItem('accessToken', data.login.accessToken);
      sessionStorage.setItem('refreshToken', data.login.refreshToken);
      // Do not resurrect credentials of the previously selected legacy account.
      sessionStorage.removeItem('tokenKey');localStorage.removeItem('userInfo');
    }
    return data;
  }).finally(() => { refreshing = null; });
  return refreshing;
}
export async function unifiedLogout() {
  // Re-read a cookie-bound session if this tab predates the current OAuth login.
  if (!sessionStorage.getItem('box.sso.csrf')) await restoreUnifiedSession();
  const result = await ssoRequest('/logout', {returnTo: sourcePath()});
  clearUnifiedCredentials();
  location.assign(result.logoutUrl);
}
export async function retryUnifiedRequest(config, retry) {
  if (config._ssoRetried) throw new Error('登录状态已失效，请重新登录');
  try {
    const data = await restoreUnifiedSession();
    if (data.reauthorizeUrl) { location.assign(data.reauthorizeUrl); throw new Error('正在恢复统一身份'); }
    if (data.needsSetup) { location.assign('/#/sso/setup'); throw new Error('请先关联 IM 账号'); }
    return retry({...config, _ssoRetried: true});
  } catch (error) {
    if (error.status === 401) { clearUnifiedCredentials(); beginUnifiedLogin(); }
    throw error;
  }
}
